<template>
  <div class="c-flex-c1" style="">

    <v-card class="ma-2">
      <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
      <div class="toolbar-pagetop">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs">

          <!-- pagination toolbar -->
          <v-row class="align-center pl-4 pr-2 pt-2 pb-2">

            <transition
            name="slide-x-reverse-transition"
            mode="out-in">

              <!-- ITEMS -->
              <div 
              v-if="selectedCount === 0"
              key="1"
              class="c-flex-r align-center subheading">

                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectAll">
                      <v-list-item-title>Select all</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn
                text
                outlined
                class="mr-2"
                @click="newQuote">
                  <v-icon>add</v-icon>
                  <div class="ml-1 text--text">
                    New quote
                  </div>
                </v-btn>

                <v-menu offset-y :close-on-content-click="false" min-width="280px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      text
                      outlined
                      v-on="on"
                    >
                      <v-icon>mdi-filter</v-icon>
                      <div class="ml-1 text--text">
                        Filter
                      </div>
                      <span v-if="activeFilterCount > 0">
                        &nbsp;|&nbsp;
                        <span class="color1--text">
                          {{ activeFilterCount }}
                        </span>
                      </span>
                    </v-btn>
                  </template>
                  <v-card class="">
                    <!-- CUSTOMER -->
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.customer = !filters.active.customer">
                      <v-icon small v-if="filters.active.customer" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Customer:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.customer">
                        <div style="background: #f7fafc;" class="pt-1 pb-1">
                          <v-layout v-for="customer of customerIDS" :key="customer.id" align-center class="pl-2">
                            {{ customer.name }}
                            <v-spacer></v-spacer>
                            <v-btn icon @click="removeCustomer(customer.id)">
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </v-layout>
                          <c-select-customer :selectedID.sync="customerID" @change="changeItem" class="ma-2 crx-box-input caption"></c-select-customer>
                        </div>
                      </div>
                    </v-expand-transition>
                    <!-- END CUSTOMER -->
                    <div class="c-hr"></div>
                    <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
                      <v-icon small v-if="filters.active.date" color="color1">
                        mdi-checkbox-marked-outline
                      </v-icon>
                      <v-icon small v-else>
                        mdi-checkbox-blank-outline
                      </v-icon>
                      &nbsp;
                      Date:
                    </v-layout>
                    <div class="c-hr"></div>
                    <v-expand-transition>
                      <div v-show="filters.active.date">
                        <div style="background: #f7fafc;" class="pt-1 pb-1">
                          <v-select
                            v-model="filters.date.mainSelect"
                            class="ma-2 input-slot-thin-border caption"
                            :items="dateFilters"
                            dense
                            hide-details
                            solo
                          ></v-select>
                          <!-- DATE OPTIONS -->
                          <div v-if="filters.date.mainSelect === 'is in the last'">
                            <v-layout class="pl-2 pr-2" style="width: 12em;">
                                <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                                &nbsp;
                                <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>
            
                                <v-select
                                  v-model="filters.date.isInTheLast_select"
                                  class="input-slot-thin-border caption"
                                  style="flex: 0 0 5em;"
                                  :items="['days', 'months']"
                                  dense
                                  hide-details
                                  solo
                                ></v-select>
                            
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is equal to'">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is between'">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                              and
                              <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                            <v-layout class="pl-2 pr-2" align-center>
                              <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                              &nbsp;
                              <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                            </v-layout>
                          </div>
                          
                        </div>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </v-menu>

              </div>

              <!-- selected count -->
              <div v-if="selectedCount > 0"
              key="2"
              class="c-flex-r align-center subheading">
                <v-btn
                icon
                class=""
                @click="selected = {}">
                  <v-icon color="color1">close</v-icon>
                </v-btn>
                <div class="text-sans font-weight-bold">
                  <span>&nbsp;{{ selectedCount }}</span>
                  selected 
                </div>
                <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
                <span class="icon--text ml-2">|</span>
                <v-btn 
                icon
                @click="onDelete">
                  <v-icon>delete_outline</v-icon>
                </v-btn>
                <!-- select menu -->
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-check-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    @click="selectAll">
                      <v-list-item-title>Select all</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectPage">
                      <v-list-item-title>Select page</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                    @click="selectNone">
                      <v-list-item-title>Select none</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

            </transition>

            <v-spacer></v-spacer>

            <div>
              <transition
              name="fade-transition"
              mode="out-in">
                <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
                  <span class="grey--text caption">LOADING...</span>&nbsp;
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-layout>
                <div v-else key="L2"></div>
              </transition>
            </div>

            <!-- item differ -->
            <!--
            <t-item-diff :item1="filters" :item2="decodedUrl">
              <v-layout 
              slot="item1Header"
              align-center class="subheading font-weight-bold pl-2 crx-toolbar">
                filters
              </v-layout>
              <v-layout 
              slot="item2Header"
              align-center class="subheading font-weight-bold pl-2 crx-toolbar">
                decodedUrl
              </v-layout>
            </t-item-diff>
            -->

          </v-row>

        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs">
        </div>
      </div>
      <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

      <!-- MAIN CONTENT -->
        
        <template>
          <!-- TOOLBAR -->

          <table class="final-table full-width lines-b no-padding">
            <colgroup ref="colgroup1">
              <col width="100px">
              <col width="100px">
              <col width="100px">
              <col width="100px">
              <col width="100px">
            </colgroup>

            <tr class="unselectable">
              <c-table-header
              title="Quote ID"
              code="id"
              class="sticky"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="Items"
              code="item_count"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="Customer"
              code="customer"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="Total"
              code="total"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>

              <c-table-header
              title="Date"
              code="date"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
        
            </tr>

            <tr style="">
              <td style="padding: 8px 12px 8px 16px;">
                <v-text-field
                v-model="filters.search.id"
                placeholder="Search..."
                hide-details
                class="crx-box-input"
                clearable
                color="color1"
                solo></v-text-field>
              </td>
              <td></td>
              <td>
                <v-text-field
                v-model="filters.search.customer"
                placeholder="Search..."
                hide-details
                class="crx-box-input"
                clearable
                color="color1"
                solo></v-text-field>
              </td>
              <td></td>
              <td></td>
            </tr>

          </table>

   

          <!-- TOOLBAR -->
          <table class="final-table lines-b pointer hover full-width">
            <colgroup ref="colgroup2">
              <col width="100px">
              <col width="100px">
              <col width="100px">
              <col width="100px">
              <col width="100px">
            </colgroup>

            <list-row
            v-for="item in items" 
            :key="item.id"
            vmode="table"
            :item="item"
            :itemsMeta="itemsMeta"
            :selected="selected"
            :searchTextID="filters.search.id"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)"
            ></list-row>

          </table>

          <!-- no item card (place this outside the scrolling div) -->
          <div v-if="(filters.search.id || '').length > 0 && items.length === 0"
          class="ma-2 pa-2">
            No items match your search "<span class="font-weight-bold">{{ filters.search.id }}</span>"
          </div>
          <!-- no item card -->
        </template>
        <!-- No sales -->
        <v-card v-if="items.length === 0" class="pa-2 ma-4 subheading elevation-0" style="border-bottom: 1px solid var(--v-hline-base);border-top: 1px solid var(--v-hline-base);">
          <v-layout v-if="searchIsActive" align-center>
            <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  No items match your search
                </span>
                <v-icon large color="red accent-4">search</v-icon>
              </v-layout>

              <div class="caption text--text text--darken-1">
                clear search
              </div>
            </div>
          </v-layout>
          <v-layout v-else-if="activeFilterCount > 0" align-center>
            <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  No items match your filters
                </span>
                <v-icon large color="red accent-4">search</v-icon>
              </v-layout>

              <div class="caption text--text text--darken-1">
                clear filters
              </div>
            </div>
          </v-layout>
          <v-layout v-else align-center>
            <img src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="36px">
            <div class="ml-2 mr-2">
              <v-layout align-center>
                <span>
                  0 quotes awaiting confirmation
                </span>
                <v-icon large color="green accent-4">check</v-icon>
              </v-layout>

              <div class="caption text--text text--darken-1">
                Quotes awaiting confirmation will be listed here
              </div>
            </div>
          </v-layout>
        </v-card>


        <!-- PAGINATION -->
        <c-pagination
        :page="page"
        :pagination="pagination"
        :filters="filters"
        @updatePageNumber="updatePageNumber"
        @goToFirstPage="goToFirstPage"
        @goToPreviousPage="goToPreviousPage"
        @goToNextPage="goToNextPage"
        @goToLastPage="goToLastPage"
        ></c-pagination>
        <!-- PAGINATION -->

      <!-- END MAIN CONTENT -->

    </v-card>


  </div>
</template>

<script>
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import ListRow from './components/list-row'
import axios from 'axios'
import Vue from 'vue'

export default {
  components: {
    ListRow
  },
  mixins: [ServerListController, ServerListBindings],
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 8,
        sortCol: 'date',
        sortAscending: false,
        customerIDS: [],
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          customer: ''
        },
        active: {
          customer: false,
          date: false
        }
      },
      isLoading: false,
      customerID: null,
      customerIDS: [],
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
      itemsMeta: {
        newID: null // this will be set to the newst created row
      }
    }
  },
  methods: {
    removeCustomer (id) {
      this.customerIDS = this.customerIDS.filter(item => item.id !== id)
    },
    changeItem (newItem) {
      var match = this.customerIDS.find(item => item.id === newItem.id)
      if (!match) {
        this.customerIDS.push(newItem)
      }
      this.$nextTick(() => {
        this.customerID = null
      })
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$router.push('/sales-quote/' + item.id)
      }
    },
    newQuote () {
      this.$axios.post('sales-quotes/create',
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          this.itemsMeta.newID = response.data.id
          console.log(this.itemsMeta.newID)
          this.page = 0
          this.filters.sortCol = 'id'
          this.filters.sortAscending = false
          Object.keys(this.filters.active).forEach(key => {
            this.filters.active[key] = false
          })
          Object.keys(this.filters.search).forEach(key => {
            this.filters.search[key] = ''
          })
          this.loadAPI()
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' quote' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('sales-quotes/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`/sales-quotes?filters=${encodedFilters}&page=${this.page}`)
        ])
        .then(axios.spread((response) => {
          var hrend = response.data.execution_time
          // console.log(hrend)
          // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
          var rows = response.data.rows
          this.pagination.rowCount = response.data.count
          this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
          if (this.items.length > rows.length) {
            this.currentIndex = 0
          }
          this.items = rows

        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  },
  activated () {
    this.loadAPI()
  },
  watch: {
    customerIDS: {
      handler (nv) {
        this.filters.customerIDS = nv.map(item => item.id)
      }
    }
  }
  
}
</script>

<style scoped lang="scss">
.hrow {
  border-bottom: 1px solid var(--v-hline-base);
  position: relative;
  overflow: hidden;
  & .header {
    cursor: pointer;
    min-height: 56px;
    display: flex;
    align-items: center;
  }
  & .cell {
    padding: 8px;
  }
}
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>

